module.exports = __webpack_public_path__ + "img/dice-4.6c97c73b.svg";